import { MtAccountSettings } from "server/models"
import { deepCopy } from "client/utils"
import { GET, POST } from "client/store/utils"
import * as types from "./types"
import { initAccountSettings } from "./reducers"


export const LoadAccountSettings = (
    accountId: number,
): Promise<types.AccountSettings> => (
    GET("/mtAccountSettings/accountId/1")
    .then((data1: MtAccountSettings) => (
        GET(`/mtAccountSettings/accountId/${accountId}`)
        .then((data2: MtAccountSettings) => {
            const superAdmin = data1 && data1.settings ? JSON.parse(data1.settings) : {}
            const account = data2 && data2.settings ? JSON.parse(data2.settings) : {}
            const newSettings = deepCopy(initAccountSettings)

            Object.keys(newSettings).forEach((module) => {
                Object.keys(newSettings[module]).forEach((param) => {
                    // copy settings from Super Admin level
                    if (superAdmin[module] && superAdmin[module][param] !== undefined) {
                        newSettings[module][param] = superAdmin[module][param]
                    }

                    // copy settings from account level
                    if (account[module] && account[module][param] !== undefined) {
                        newSettings[module][param] = account[module][param]
                    }
                })
            })

            return newSettings
        })
    ))
)

export const SaveAccountSettings = (
    accountId: number,
    settings: types.AccountSettings,
) => {
    const data: MtAccountSettings = {
        accountId,
        settings: JSON.stringify(settings),
    }
    return POST(
        "/mtAccountSettings/save",
        JSON.stringify(data),
    )
}
